var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSolid = function SvgEmailSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50293 6.384L10.4999 10.382L18.4969 6.384C18.4673 5.87444 18.244 5.39549 17.8728 5.04523C17.5015 4.69497 17.0103 4.49991 16.4999 4.5H4.49993C3.98951 4.49991 3.49838 4.69497 3.12711 5.04523C2.75584 5.39549 2.53253 5.87444 2.50293 6.384Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.61816L10.5 12.6182L2.5 8.61816V14.5002C2.5 15.0306 2.71071 15.5393 3.08579 15.9144C3.46086 16.2895 3.96957 16.5002 4.5 16.5002H16.5C17.0304 16.5002 17.5391 16.2895 17.9142 15.9144C18.2893 15.5393 18.5 15.0306 18.5 14.5002V8.61816Z",
    fill: "#919191"
  })));
};
export default SvgEmailSolid;